import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-383d1793"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "spin ion-text-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"100px"},
    src: _imports_0
  })
], -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["poster"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "ion-text-center ion-margin-top"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "home-top-anchor",
  style: {"position":"relative","top":"-30px"}
}, null, -1))
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["href"]
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_slides = _resolveComponent("slides")!
  const _component_section_header = _resolveComponent("section-header")!
  const _component_info_card_list = _resolveComponent("info-card-list")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            class: "ion-no-padding",
            fixed: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, { color: "primary" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_back_button, { "default-href": "/" })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, {
                    class: "ion-text-center",
                    "router-link": "/profile"
                  }, {
                    default: _withCtx(() => [
                      ($setup.userLoggedIn)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                            _createTextVNode("Hi"),
                            ($setup.currUser.name)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_2, ", " + _toDisplayString($setup.currUser.name), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "primary" }, {
                    default: _withCtx(() => [
                      ($setup.userLoggedIn)
                        ? (_openBlock(), _createBlock(_component_ion_button, {
                            key: 0,
                            "router-link": "/notifications"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "icon-only",
                                icon: $setup.notificationsOutline
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            class: "ion-no-padding",
            fixed: ""
          }, {
            default: _withCtx(() => [
              ($setup.loadingAppPublicData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _hoisted_4,
                    _createVNode(_component_ion_spinner)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    ($setup.topBanners)
                      ? (_openBlock(), _createBlock(_component_swiper, {
                          key: 0,
                          onSwiper: $setup.setSwiperInstance,
                          modules: $setup.modules,
                          slidesPerView: 1,
                          autoplay: { delay: $setup.settings.videoBannerAutoplayDelay || 8000 },
                          speed: 300,
                          loop: true,
                          pagination: true,
                          autoHeight: false
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_swiper_slide, null, {
                              default: _withCtx(() => [
                                _createElementVNode("video", {
                                  id: "video-player",
                                  ref: "videoPlayer",
                                  style: {"width":"100%"},
                                  onTouchstart: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.startTimer && $setup.startTimer(...args))),
                                  onTouchend: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.checkTapVideo && $setup.checkTapVideo(...args))),
                                  onEnded: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.onVideoEnded && $setup.onVideoEnded(...args))),
                                  onPlay: _cache[3] || (_cache[3] = ($event: any) => ($setup.videoSlides.autoplay.stop())),
                                  onPause: _cache[4] || (_cache[4] = ($event: any) => ($setup.videoSlides.autoplay.start())),
                                  poster: require('@/assets/mlp_video_thumbnail.jpg')
                                }, [
                                  _createElementVNode("source", {
                                    src: require('@/assets/mlp.mp4'),
                                    type: "video/mp4"
                                  }, null, 8, _hoisted_7)
                                ], 40, _hoisted_6)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onSwiper", "modules", "autoplay"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_toolbar, { style: {"margin-top":"5px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_segment, {
                          value: "",
                          onIonChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.onSegmentChanged($event))),
                          scrollable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.placeTypes, (type) => {
                              return (_openBlock(), _createBlock(_component_ion_segment_button, {
                                key: type.id,
                                value: type.title
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_avatar, { style: {"width":"56px","height":"56px"} }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        style: {"width":"56px","height":"56px"},
                                        src: type.imageLink
                                      }, null, 8, _hoisted_8)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.getLocalizedStr(type, 'title', 'titleEn')), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_slides, {
                      banners: $setup.homeBanners,
                      userStickers: $setup.userStickers,
                      maxStickerCount: $setup.currUser.maxStickerCount
                    }, null, 8, ["banners", "userStickers", "maxStickerCount"]),
                    _createElementVNode("div", null, [
                      ($setup.userLoggedIn && $setup.loadingUserData)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_ion_spinner)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createVNode(_component_section_header, {
                              icon: $setup.paw,
                              title: $setup.t('myPets')
                            }, null, 8, ["icon", "title"]),
                            _createVNode(_component_slides, { userPets: $setup.userPets }, null, 8, ["userPets"]),
                            _createVNode(_component_section_header, {
                              icon: $setup.logoWhatsapp,
                              title: $setup.t('myStickers'),
                              count: $setup.userStickers.length,
                              max: $setup.currUser.maxStickerCount,
                              routerLink: "/stickers"
                            }, null, 8, ["icon", "title", "count", "max"]),
                            _createVNode(_component_slides, {
                              userStickers: $setup.userStickers,
                              maxStickerCount: $setup.currUser.maxStickerCount
                            }, null, 8, ["userStickers", "maxStickerCount"]),
                            ($setup.userOrders.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _createVNode(_component_section_header, {
                                    icon: $setup.receiptOutline,
                                    title: $setup.t('myOrders'),
                                    routerLink: "/orders"
                                  }, null, 8, ["icon", "title"]),
                                  _createVNode(_component_slides, { userOrders: $setup.userOrders }, null, 8, ["userOrders"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _createVNode(_component_section_header, {
                      icon: $setup.flame,
                      title: $setup.t('infos'),
                      routerLink: "/info-overview"
                    }, null, 8, ["icon", "title"]),
                    _hoisted_12,
                    _createVNode(_component_info_card_list, {
                      style: {"padding-left":"5px","padding-right":"5px"},
                      infos: $setup.infos,
                      anchorClass: "home-top-anchor"
                    }, null, 8, ["infos"]),
                    _createVNode(_component_ion_modal, {
                      "is-open": $setup.isAboutUsModalOpened,
                      onDidDismiss: _cache[7] || (_cache[7] = ($event: any) => ($setup.isAboutUsModalOpened = false))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_header, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_toolbar, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_buttons, { slot: "start" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_button, {
                                      slot: "icon-only",
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.isAboutUsModalOpened = false))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, { icon: $setup.close }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_content, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card, { class: "no-border-card" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card_header, { class: "ion-text-center" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_card_title, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("h1", null, _toDisplayString($setup.t('aboutUs')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_card_content, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: "ion-text-center",
                                      style: {"white-space":"pre-line","font-size":"16px"},
                                      innerHTML: $setup.locale == 'zh' ? $setup.settings.introduction : $setup.settings.introductionEn
                                    }, null, 8, _hoisted_13)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_card_header, { class: "ion-text-center" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_card_title, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("h1", null, _toDisplayString($setup.t('contactUs')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_card_content, { class: "ion-text-center contact-info" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h2", null, [
                                      _createVNode(_component_ion_icon, {
                                        class: "icon-md",
                                        icon: $setup.mail
                                      }, null, 8, ["icon"]),
                                      _createTextVNode(" " + _toDisplayString($setup.t('companyEmail')), 1),
                                      _createElementVNode("a", {
                                        href: `mailto:${$setup.settings.companyEmail}`
                                      }, _toDisplayString($setup.settings.companyEmail), 9, _hoisted_14)
                                    ]),
                                    _createElementVNode("h2", null, [
                                      _createVNode(_component_ion_icon, {
                                        class: "icon-md",
                                        icon: $setup.call
                                      }, null, 8, ["icon"]),
                                      _createTextVNode(" " + _toDisplayString($setup.t('companyPhone')), 1),
                                      _createElementVNode("a", {
                                        href: `tel:${$setup.settings.companyPhone}`
                                      }, _toDisplayString($setup.settings.companyPhone), 9, _hoisted_15)
                                    ]),
                                    _createElementVNode("h2", null, [
                                      _createVNode(_component_ion_icon, {
                                        class: "icon-md",
                                        icon: $setup.location
                                      }, null, 8, ["icon"]),
                                      _createTextVNode(" " + _toDisplayString($setup.t('companyAddress')) + _toDisplayString($setup.locale == 'zh' ? $setup.settings.companyAddress : $setup.settings.companyAddressEn), 1)
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["is-open"])
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}